import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import { LogOut } from 'lucide-react';

// Pages
import DashboardHome from './DashboardHome';
import GroupsPage from './GroupsPage';
import StudentsPage from './StudentsPage';
import TeachersPage from './TeachersPage';
import SubjectsPage from './SubjectsPage';
import TemperamentPage from './TemperamentPage';
import LanguagePage from './LanguagePage';
import CertificatesPage from './CertificatesPage';
import ClubsPage from './ClubsPage';
import CorruptionPage from './CorruptionPage';
import LeadershipPage from './LeadershipPage';
import EventsPage from './EventsPage';
import RegulationsPage from './RegulationsPage';
import SuicideTestPage from './SuicideTestPage';

const AdminDashboard = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase() || '?';
  };

  return (
    <div className="dashboard-layout">
      <Sidebar />
      
      <main className="main-content">
        <header className="main-header">
          <div className="page-title">
            <h1>Buxoro Xalqaro Tibbiyot Texnikumi</h1>
            <p>Ta'lim jarayonlarini boshqarish elektron platformasi</p>
          </div>
          
          <div className="user-menu">
            <div className="user-info">
              <div className="name">{user?.first_name} {user?.last_name}</div>
              <div className="role">{user?.role_display}</div>
            </div>
            <div className="user-avatar">
              {getInitials(user?.first_name, user?.last_name)}
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={18} />
              Chiqish
            </button>
          </div>
        </header>

        <div className="page-content">
          <Routes>
            <Route path="/" element={<DashboardHome />} />
            <Route path="/groups" element={<GroupsPage />} />
            <Route path="/students" element={<StudentsPage />} />
            <Route path="/teachers" element={<TeachersPage />} />
            <Route path="/courses" element={<SubjectsPage />} />
            <Route path="/clubs" element={<ClubsPage />} />
            <Route path="/temperament" element={<TemperamentPage />} />
            <Route path="/language" element={<LanguagePage />} />
            <Route path="/certificates" element={<CertificatesPage />} />
            <Route path="/leadership" element={<LeadershipPage />} />
            <Route path="/corruption" element={<CorruptionPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/regulations" element={<RegulationsPage />} />
            <Route path="/suicide-test" element={<SuicideTestPage />} />
          </Routes>
        </div>
      </main>
    </div>
  );
};

export default AdminDashboard;
